export const DEBUG = false;
export const URL_TEST = {
    unidad_revision: "http://172.16.1.7/WS/unidad-revision.php?id_usuario=rigozodac&contrasena=MALDITASEA80",
    unidad_checks: "http://172.16.1.7/WS/todas-unidades-revision.php?id_usuario=rigozodac&contrasena=MALDITASEA80",
    unidad_supervisor:"http://172.16.1.7/WS/unidades_por_supervisor.php?id_usuario=rigozodac&contrasena=MALDITASEA80"
}

export const URL_SERVER = {
    unidad_revision: "unidad-revision",
    unidad_checks: "todas-unidades-revision",
    unidad_supervisor:"unidades_por_supervisor"
}